<template>
  <div id="app">
    <Loading :class="{loaded}" v-show="!loaded" />
    <first-Component v-if="$route.name!=='Login'"></first-Component>
    <div id="scroller-wrapper" data-scrollbar >
      <router-view  />
    </div>
  </div>
</template>

<script>
  import  {WOW} from 'wowjs'
  import Scrollbar from 'smooth-scrollbar';
  import firstComponent from './components/first'
  import Loading from './components/loading.vue'
  export default {
    name: 'App',
    data(){
      return{
        loaded:false,
        wow:'',
        scrollbar:''
      }
    },
    watch:{
      '$route':'init'
    },
    components:{firstComponent,Loading},
    mounted() {
      this.wow=new WOW();
      this.init()
      this.$router.beforeEach((to, from, next) => {
        Scrollbar.destroyAll()
        next()
      })
    },
    methods:{
      init(){
        this.$nextTick(()=>{
          this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
          this.wow.init()
           this.loaded=false
          setTimeout(()=>{
            this.loaded=true
          },600)
          let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
          scrollbar.scrollTo(0,0)
          window.pageYOffset=this.scrollbar.scrollTop
          this.scrollbar.addListener(() => {
            this.wow.scrollHandler()
            window.pageYOffset=this.scrollbar.scrollTop
          });
        })
      }
    }
  }
</script>

<style>
    /*.viewer-canvas > img{*/
    /*    height:200px !important;*/
    /*    width:20% !important;*/
    /*    margin-left: 40% !important;*/
    /*    object-fit: cover;*/
    /*    margin-top:20% !important;*/
    /*}*/
  .BMap_cpyCtrl
  {
    display:none;
  }
  .anchorBL{
    display:none;
  }
  p,ul,a{
    margin: 0;
    padding: 0;
    text-decoration: none;
  }
  body{
    margin:0;
    padding: 0;
    animation-delay: 3s;
  }
  .el-input--suffix .el-input__inner{
    background-color: rgba(255,255,255,.3) !important;
    border: none !important;
    font-size: 14px !important;
    height:30px !important;
    color:#0C3665;
  }
  .el-input__icon{
    line-height: normal !important;
  }
  .el-scrollbar{
    background-color: transparent !important;
  }
  .el-select-dropdown__item{
    font-size: 12px !important;
    height:35px !important;
  }
  a{
    text-decoration: none;
  }
  .el-carousel__button{
    height:10px !important;
    width:10px !important;
    border-radius: 50% !important;
    background-color: #C7000C !important;
  }
  .donghua{
    height:100vh;
    width:100%;
    position: absolute;
    top:0;
    left:0;
    z-index: 999;
    color:white;
    background-color: black;
    animation-duration: 600ms;
    animation-delay: 100ms;
    background-image: url("./assets/home/shipping-containers-1150062.png");
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color:black;
    width:100%;
    overflow: hidden;
  }
  #scroller-wrapper{
    position: relative;
    height: 100vh;
    overflow: hidden;
    /* z-index: 101; */
  }
  .scrollbar-thumb{
    width:3px !important;
    background-color: #0068B7 !important;
  }
  .scrollbar-track-y{
    width:3px !important;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  @media screen and (max-width:1680px){
    .el-scrollbar{
     height:80px !important;
    }
  }
  @media screen and (min-width:2000px){
    .el-scrollbar{
      height:80px !important;
    }
  }
</style>
